import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import themeConfig from './theme';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LanguageProvider, useLanguage } from './i18n/LanguageContext';

const ThemedApp = () => {
  const { lang } = useLanguage();

  const dynamicTheme = React.useMemo(() => createTheme({
    ...themeConfig,
    direction: lang === 'ar' ? 'rtl' : 'ltr',
    typography: {
      ...themeConfig.typography,
      fontFamily: lang === 'ar'
        ? '"Cairo", "Rubik", "Helvetica", "Arial", sans-serif'
        : '"Rubik", "Helvetica", "Arial", sans-serif',
    }
  }), [lang]);

  return (
    <ThemeProvider theme={dynamicTheme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <LanguageProvider>
      <ThemedApp />
    </LanguageProvider>
  </React.StrictMode>
);

reportWebVitals();
